import { INVOICE_FORMAT } from '../constants/payment.constants';

const getInvoiceFormatsForCountry = (): INVOICE_FORMAT[] => {
  return [INVOICE_FORMAT.EHF, INVOICE_FORMAT.PDF];
};

export const paymentHelper = {
  getInvoiceFormatsForCountry
};
